// Force webpack to include our module by importing it where it is used.
// It is also included in Common.js. However, webpack seems to
// remove selectize from dist regardless, unless loaded here.
import 'selectize';
import { SelectizeEscapeHandler, SelectizeItem } from '../default/SelectizeTypes';

interface LocalizedProperty {
    en?: string;
    no?: string;
}

export interface SelectizeFeideOrganization extends SelectizeItem {
    logo: string;
    name: LocalizedProperty;
}

class SelectOrg {
    constructor() {
        $('#org_selector').val();
        // Get the input box and focus after loading
        const orgSelectorFilter = document.getElementById('org_selector_filter');
        if (orgSelectorFilter !== null) {
            orgSelectorFilter.focus();
        }

        function insertCompNameAndLogoInInputBox() {
            const compName = document.querySelector('.orglist_item.chosen .orglist_name')!;
            const compLogo = <HTMLImageElement>document.querySelector('.orglist_item.chosen .orglist_logo')!;
            const selectorFilter = (<HTMLInputElement>document.getElementById('org_selector_filter')!);
            selectorFilter.style.background = `url(${compLogo.src}) no-repeat`;
            selectorFilter.style.backgroundSize = '34px auto';
            selectorFilter.style.backgroundPosition = '0.8rem center';
            selectorFilter.style.paddingLeft = '3.8rem';
            selectorFilter.value = String(compName.innerHTML);
        }

        function removeLogo() {
            const selectorFilter = (<HTMLInputElement>document.getElementById('org_selector_filter')!);
            selectorFilter.style.background = '';
            selectorFilter.style.padding = '0 1rem';
        }

        function updateHitsFound(hitAmount: number, foundText: string, allItems: JQuery<HTMLElement>) {
            if (hitAmount > 0) {
                // Update text for screen reader
                $('#orglist').css('display', 'block');
                $('#hits-found').text(`${foundText} ${hitAmount}`);
                $('#hits-found').css('display', 'block');
                if (hitAmount <= 3) {
                    // If list is small enough hide the scroll bar for better appearance
                    $('#orglist_wrapper').css('overflow-y', 'hidden');
                }
            } else {
                // If no hits are found the list should be hidden
                // and hitfound updated for screen reader
                $('.hit-label').attr('role', 'status');
                $('.hit-label').attr('aria-live', 'polite');
                $('#orglist').css('display', 'none');
                $('#hits-found').text(`${foundText} 0`);
                $('#hits-found').css('display', 'block');
            }
            // Update the aria label for each item in the list to indicate their position
            allItems.each(function updateAriaLabel(index) {
                const orgName = $(this).find('.orglist_name').html();
                const hitNum = index + 1;
                $(this).attr('aria-label', `${orgName} item ${hitNum}`);
            });
        }

        function showRecentList(recentItems: JQuery<HTMLElement>) {
            $('.recent_outside').css('display', 'none');
            $('.recent_outside').attr('aria-label', '');
            $('.recent_outside').removeClass('match');
            recentItems.css('display', 'block');
            recentItems.addClass('match');
            // If the whole list is shown again the seperation blue line for the last_recent item needs
            // to be inserted back in since its removed while filtering. This ensures that there will always be
            // seperation between recent items and non-recent items
            recentItems.each((index) => {
                if (index + 1 === recentItems.length) {
                    recentItems[index].setAttribute('class', 'orglist_item recent last_recent');
                }
            });
        }

        function showOrgList(allItems: JQuery<HTMLElement>) {
            $('.orglist_item').css('display', 'none');
            $('.orglist_item').attr('aria-label', '');
            $('.orglist_item').removeClass('match');
            $('.orglist_item').removeClass('last_recent'); // RM the blue line when typing
            allItems.css('display', 'block');
            allItems.addClass('match');
        }

        /*
        *  Sort list, prioritizing start of word string match, followed by string
        *  match elsewhere in the word. If there is no input it will sort on locale
        *  (re-ordering the list to original order).
        */
        function sortFilteredList(input: String) {
            const ul = document.getElementById('orglist')!;
            const sorter = new Intl.Collator('nb', { usage: 'sort' });

            // The way that the recents list is generated is different from the authengine codebase
            // Thus this added function is needed to sort if there is input but otherwise return back to original list
            let listItems = [];
            if (input.length > 0) {
                listItems = $(ul).children('li:visible').not('#recent_label_li')
                    .toArray();
            } else {
                listItems = $(ul).children('li:visible').not('.recent').not('#recent_label_li')
                    .toArray();
            }

            listItems.sort((aItem, bItem) => {
                const aOrgName = aItem.getAttribute('org_name') || '';
                const bOrgName = bItem.getAttribute('org_name') || '';
                const aMatchOnStartOfWord = aOrgName.indexOf(input.toLowerCase()) === 0;
                const bMatchOnStartOfWord = bOrgName.indexOf(input.toLowerCase()) === 0;

                // Prioritize start of word matching
                if (!aMatchOnStartOfWord && bMatchOnStartOfWord) {
                    return 1;
                }
                if (aMatchOnStartOfWord && !bMatchOnStartOfWord) {
                    return -1;
                }
                return sorter.compare(aOrgName, bOrgName);
            });

            // Appending will move current item in list to new position
            // eslint-disable-next-line no-restricted-syntax
            for (const li of listItems) {
                ul.appendChild(li);
            }
        }

        function insertOrgNameToAriaLabels(allItems: JQuery<HTMLElement>) {
            allItems.each(function insertOrgNameToAriaLabel(index) {
                const orgName = $(this).find('.orglist_name').html();
                const hitNum = index + 1;
                $(this).attr('aria-label', `${orgName} item ${hitNum}`);
            });
        }

        function showListWithoutFoundLabel() {
            $('#orglist').css('display', 'block');
            $('#orglist_wrapper').css('overflow-y', 'visible');
            $('.recents_label').css('display', '');
            $('#hits-found').text('');
            $('.orglist_item').css('display', 'block');
            insertOrgNameToAriaLabels($('.orglist_item'));
        }

        function onInputChange(currentValue: string) {
            // Recently selected items are shown on the top part of the list
            const currentValueEscaped = $.escapeSelector(currentValue);
            // eslint-disable-next-line max-len
            const recentItemsMatched = $(`.recent[org_name*="${currentValueEscaped}"]`);
            const foundTextItem = document.getElementById('hits-found');
            let foundText = null;
            // Get the transifex translated label for screen reader
            if (foundTextItem !== null) {
                foundText = foundTextItem.getAttribute('label');
            } else {
                foundText = 'found';
            }
            // If there is recent affiliations, show items
            showRecentList(recentItemsMatched);
            $('#orglist').css('display', 'block');
            if (currentValue.length > 0) {
                $('#orglist_wrapper').css('overflow-y', 'scroll');
                $('.recents_label').css('display', 'none');
                // Matched on org_name and org_id
                const itemsToShow = recentItemsMatched.add($(`.orglist_item[org_name*="${currentValueEscaped}"]`));
                const allItems = itemsToShow.add($(`.orglist_item[org_id*="${currentValueEscaped}"]`));
                showOrgList(allItems);
                sortFilteredList(currentValue);
                const hitAmount = $('.orglist_item.match').length;
                // Typing char and matching with items should filter the list as the user types along:
                if (foundText !== null) {
                    updateHitsFound(hitAmount, foundText, allItems);
                }
            } else {
                // this gets triggers when deleting all the text in the input box
                removeLogo();
                $('.orglist_item').removeClass('chosen');
                const allRecentItems = $('.recent');
                showRecentList(allRecentItems);
                showListWithoutFoundLabel();
                sortFilteredList('');
            }
        }

        $('.orglist_item').on('click', function onOrgListClick() {
            $('.orglist_item').removeClass('chosen');
            $(this).addClass('chosen');
            const orgID = $(this).attr('org_id');
            if (orgID !== undefined) {
                $('#org_selector').val(orgID);
            }
            insertCompNameAndLogoInInputBox();
            $('#orglist').css('display', 'none');
            $('#orglist_wrapper').css('overflow-y', 'hidden');
            $('#selectorg_button').focus();
            $('#selectorg_button').prop('disabled', false);
        });

        $('#org_selector_filter').on('click', () => {
            const chosenItem = document.getElementsByClassName('orglist_item chosen');
            // If item already selected only show selected item
            if (chosenItem.length > 0) {
                const compName = document.getElementsByClassName('orglist_item chosen')[0].getAttribute('org_name');
                const itemsToShow = $(`.orglist_item[org_name*="${compName}"]`);
                $('#orglist').css('display', 'block');
                $('.recents_label').css('display', 'none');
                showOrgList(itemsToShow);
            } else {
                $('#orglist').css('display', 'block');
                $('#orglist_wrapper').css('overflow-y', 'visible');
            }
        });

        // While typing the list need to appear and filter results after 2 characters.
        $('#org_selector_filter').on('input', function updateFilter() {
            let currentValue = $(this).val() as string;
            currentValue = currentValue.toLowerCase();
            onInputChange(currentValue);
            // Recently selected items are shown on the top part of the list
        });

        const setFocusToInputBoxEnd = (inputBox: HTMLInputElement) => {
            // Set focus at the end of the string
            const inputLen = inputBox.value.length;
            inputBox.selectionStart = inputLen;
            inputBox.selectionEnd = inputLen;
            inputBox.focus();
        };

        $('.orglist_item').keydown(function onOrgListKeyDown(event) {
            if (event.keyCode === 13) { // Enter key
                event.preventDefault();
                if (!$(this).hasClass('chosen')) {
                    $('.orglist_item').removeClass('chosen');
                    $(this).addClass('chosen');
                    const orgID = $(this).attr('org_id');
                    if (orgID !== undefined) {
                        $('#org_selector').val(orgID);
                    }
                    // Complete text in input field once affiliation is clicked on
                    insertCompNameAndLogoInInputBox();
                    $('#orglist').css('display', 'none');
                    $('#orglist_wrapper').css('overflow-y', 'hidden');
                    $('#selectorg_button').prop('disabled', false);
                    $('#selectorg_button').focus();
                } else {
                    $('.orglist_item').removeClass('chosen');
                    $('#selectorg_button').prop('disabled', true);
                    $('#org_selector').val('');
                }
            } else if (event.keyCode === 38) { // Up arrow
                event.preventDefault();
                // exclude invisible items and recent label list item with keynav
                const visibleItem = $(this).closest('li').prevAll('li:visible').not('#recent_label_li')
                    .first();
                if (visibleItem.length > 0) {
                    visibleItem.focus();
                } else {
                    const inputBox = document.getElementById('org_selector_filter')! as HTMLInputElement;
                    setFocusToInputBoxEnd(inputBox);
                }
            } else if (event.keyCode === 40) { // Down arrow
                // Only navigate through visible items
                event.preventDefault();
                const visibleItem = $(this).closest('li').nextAll('li:visible').not('#recent_label_li')
                    .first();
                if (visibleItem.length > 0) {
                    visibleItem.focus();
                }
            }
        });

        $('#org_selector_filter').keydown((event) => {
            const currentValue = (document.getElementById('org_selector_filter') as HTMLInputElement).value;
            if (event.keyCode === 13) { // Enter key
                event.preventDefault();
                if (currentValue.length > 0) {
                    $('.orglist_item.match').first().focus();
                } else {
                    $('.orglist_item').first().focus();
                }
            } else if (event.keyCode === 40) { // Down arrow
                if ($('#orglist').css('display') !== 'block') {
                    event.preventDefault();
                    $('#orglist').css('display', 'block');
                } else {
                    // eslint-disable-next-line no-lonely-if
                    event.preventDefault();
                    if (currentValue.length > 0) {
                        $('.orglist_item.match').first().focus();
                    } else {
                        $('.orglist_item').first().focus();
                    }
                }
            }
        });
    }

    // eslint-disable-next-line class-methods-use-this
    drawSelectize(type: string, data: SelectizeFeideOrganization, escape: SelectizeEscapeHandler) {
        let imageSrc = 'img/home_organization.png';
        if (data.logo) {
            imageSrc = `orglogos/${data.logo}`;
        }
        const text = escape(data.text);
        return `<div class="${type}">
                  <div class="media">
                    <div class="media-left">
                      <span class="helper"></span>
                      <img src="${imageSrc}" alt="" />
                    </div>
                    <div class="media-body align-middle">
                      ${text}
                    </div>
                  </div>
                </div>
               `;
    }
}

export default SelectOrg;
